import OAuthService from 'src/app/auth/services/oAuthService';

const CACHE_TTL_MS = 5 * 60 * 1000;
const HISTORY_YEARS_BACK = 3;
const cache = new Map();

const baseUrl = () => process.env.REACT_APP_RESOURCE_API_KEY_URL;

const buildBudgetUrl = (year, territoryId, budgetType) => (territoryId
    ? `${baseUrl()}api/salesBudget/v2/get-monthly-budgets-for-territory?year=${year}&territoryId=${territoryId}&type=${budgetType}`
    : `${baseUrl()}api/salesBudget/v2/get-monthly-budgets-for-year?year=${year}&type=${budgetType}`);

const buildSalesUrl = (year, territoryId) => {
    const fromDate = encodeURIComponent(`${year}-01-01`);
    const toDate = encodeURIComponent(`${year}-12-31`);
    const dateType = Number(year) >= new Date().getFullYear() ? 'PLANNED' : 'ACTUAL';
    const url = `${baseUrl()}api/get-customer-monthly-sales-by-date-range?from=${fromDate}&to=${toDate}&dateType=${dateType}`;
    return territoryId ? `${url}&territoryId=${territoryId}` : url;
};

const loadCached = (key, url) => {
    const hit = cache.get(key);
    if (hit && Date.now() - hit.at < CACHE_TTL_MS) return hit.promise;

    const promise = OAuthService.getList(url)
        .then(res => (Array.isArray(res?.data) ? res.data : []))
        .catch(() => {
            cache.delete(key);
            return [];
        });
    cache.set(key, { at: Date.now(), promise });
    return promise;
};

export const loadHistoryBudgets = (year, territoryId, budgetType) =>
    loadCached(`B|${year}|${territoryId || 'ALL'}|${budgetType}`, buildBudgetUrl(year, territoryId, budgetType));

export const loadHistorySales = (year, territoryId) =>
    loadCached(`S|${year}|${territoryId || 'ALL'}`, buildSalesUrl(year, territoryId));

export const getHistoryYears = (budgetYear) => {
    const target = Number(budgetYear);
    if (!target) return [];
    return Array.from({ length: HISTORY_YEARS_BACK + 1 }, (_, i) => target - i);
};

export const prefetchHistorySources = ({ territoryId, budgetYear, budgetType }) => {
    getHistoryYears(budgetYear).forEach(year => {
        loadHistoryBudgets(year, territoryId, budgetType);
        loadHistorySales(year, territoryId);
    });
};
